//Author : Kavitha Sri

import { currencyByCountry, findedLocation } from "../../helpers/Helper";
import { currencyCode } from "components/constants/dsmConstants";
import React, { InputHTMLAttributes } from "react";
import { FormFeedback, Input, InputGroup, Label } from "reactstrap";

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    /**@param {any} type defines which type of input control to display */
    type?: any;
    /** @param {any} name reference of the elements*/
    name?: any;
    /** @param {any} label specifies the title of the text track */
    label: any,
    /** @param {any} id defines the id of the DOM element */
    id: any,
    /** @param {any} className return the value of an element's class*/
    className?: any,
    /** @param {any} placeholder what kind of information is expected in the field*/
    placeholder?: any;
    /** @param {any} value is used to set or get the value for the input field*/
    value: any;
    /** @param {any} onChange is detects when the value of an input element changes.*/
    onChange?: any;
    /** @param {any} onBlur is fires the moment that the element loses focus*/
    onBlur?: any;
    /** @param {any} invalid occurs when you're trying to perform on an invalid value.*/
    invalid?: any;
    /** @param {any} error interferes with the proper operation of the program*/
    error: any;
    touched?: any;
}

export const CustomAmount = React.forwardRef(({ name, placeholder, value, onChange, onBlur, invalid, error, label, id, touched }: inputProps, ref) => {

    return (
        <>
            <Label className="mt-3 mb-1">{label}</Label>
            <InputGroup>
                <div className="input-group-text">{findedLocation().CountryCode == "in" ? "Rs." : "AED"}</div>
                <Input
                    type="number"
                    name={name}
                    className="form-control"
                    id={id}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    error={error}
                    invalid={invalid}
                    touched={touched}
                />
            </InputGroup>
            {
                error ? (
                    <span className="text-danger fa-xs" >{error}</span>
                ) : null
            }
        </>
    )
})